import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';

export default function LatestArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10 md:mb-14">
            <div>
              <p className="text-sm font-semibold uppercase tracking-widest text-foreground-400 mb-2">
                最新上架
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
                新作<span className="italic font-normal text-secondary-500">推荐</span>
              </h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg leading-relaxed">
              每天更新最新韩国漫画资源，为您精选优质新作，让您第一时间追更最热韩漫，不错过任何一部精彩作品。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {latestComics.map((comic, idx) => (
              <div key={comic.id} className="group">
                <Link to={`/article/${comic.slug}`} className="block">
                  <div className="relative rounded-2xl overflow-hidden mb-4" style={{ aspectRatio: '3/4' }}>
                    <img
                      src={comic.imageUrl}
                      alt={comic.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      {comic.isNew && (
                        <span className="bg-accent-500 text-background-50 text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap">
                          NEW
                        </span>
                      )}
                    </div>
                  </div>

                  <span className="inline-block bg-accent-100 text-accent-900 text-xs font-medium px-2.5 py-1 rounded-full mb-2 whitespace-nowrap">
                    {comic.category}
                  </span>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {comic.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                    {comic.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i> {comic.author}
                    </span>
                    <span>{comic.chapters}话</span>
                    <span>{comic.views}</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/category/fantasy"
              className="inline-flex items-center gap-2 text-foreground-700 hover:text-primary-500 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多新作
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}